<template>
  <div
    class="container v-content-container tooltip-wrapper popup-wrapper"
    :key="componentKey"
  >
    <div class="row">
      <div class="col-xs-12">
        <h1>
          <i class="fa fa-user fa-fw fa-list-alt"></i>
          {{ $label("event.instructors", "Instructors") }}
          <router-link
            :to="{ name: 'NewEventInstructor' }"
            class="btn btn-v-lightgreen-white pull-right"
            v-tooltip="{
              content: $label('event.new_instructor', 'New instructor'),
              classes: 'custom-tooltip'
            }"
          >
            <i class="fa fa-fw fa-lg fa-plus"></i>
          </router-link>
        </h1>
      </div>
    </div>

    <navigation-tabs></navigation-tabs>

    <div class="row mt-8">
      <div class="col-xs-12">&nbsp;</div>
    </div>

    <alert-box
      v-show="failedRequest"
      type="warning"
      :closeable="false"
      :show-icon="false"
    >
      {{
        $label(
          "event.instructors_failed_request",
          "Request failed while loading instructors."
        )
      }}
    </alert-box>

    <Table
      v-show="!failedRequest"
      id="instructors-table"
      :loading="loading"
      :columns="[
        {
          title: 'Name',
          field: 'name',
          id: row => `instructor-name-${row.id}`
        },
        {
          title: 'Email',
          field: 'email',
          id: row => `instructor-email-${row.id}`
        },
        {
          title: 'Phone number',
          id: row => `instructor-phone-number-${row.id}`,
          tooltip: row =>
            '<div class=&quot;tooltip-title-background&quot;><p class=&quot;tooltip-title&quot;><i class=&quot;text-primary fa fa-lg fa-fw fa-user&quot;></i> <b>' +
            (Boolean(row.first_name && row.first_name)
              ? beautifyName(row.first_name, row.first_name)
              : '') +
            '</b></p></div>' +
            '<i class=&quot;text-v-green fa  fa-lg fa-fw fa-mobile&quot;></i>' +
            (Boolean(
              row.phone_number &&
                row.phone_number.prefix &&
                row.phone_number.number
            )
              ? `+${row.phone_number.prefix}${row.phone_number.number}`
              : '') +
            '<br><i class=&quot;text-v-green fa fa-lg fa-fw fa-phone&quot;></i> <br><i class=&quot;text-v-green fa fa-lg fa-fw fa-tag&quot;></i> ',
          icon: row =>
            Boolean(
              row.phone_number &&
                row.phone_number.prefix &&
                row.phone_number.number
            )
              ? 'mobile'
              : null,
          value: row =>
            Boolean(
              row.phone_number &&
                row.phone_number.prefix &&
                row.phone_number.number
            )
              ? `+${row.phone_number.prefix}${row.phone_number.number}`
              : '-'
        },
        {
          title: 'Categories',
          id: row => `instructor-categories-${row.id}`,
          value: row => getCategoryNames(row.categories)
        }
      ]"
      :actions="[
        {
          type: 'detail',
          onClick: row => {
            $router.push({
              name: 'EventInstructorDetails',
              params: { instructor_id: row.id }
            });
          }
        },
        {
          type: 'delete',
          id: row => `delete-instructor-button-${row.id}`,
          onClick: row => deleteInstructor(row.id)
        }
      ]"
      :data="instructors"
      :meta="metaData"
      @fetchQuery="
        params => {
          fetchParams = params;
          getInstructors({
            //
          });
        }
      "
    >
      <div
        id="action-dropdown"
        slot="toolbar"
        class="btn-group"
        style="margin-left: 5px;"
      >
        <button
          type="button"
          class="btn btn-primary dropdown-toggle"
          data-toggle="dropdown"
        >
          <i class="fa fa-refresh"></i> &nbsp;
          {{ $label("common.actions", "Actions") }} &nbsp;<span
            class="caret"
          ></span>
        </button>
        <ul class="dropdown-menu" role="menu">
          <li>
            <router-link :to="{ name: 'NewEventInstructor' }"
              ><i class="text-primary fa fa-fw fa-lg fa-plus"></i>
              {{
                $label("event.new_instructor", "New instructor")
              }}</router-link
            >
          </li>
        </ul>
      </div>
    </Table>

    <div class="row mb-8">
      <div class="col-xs-12">&nbsp;</div>
    </div>
  </div>
</template>

<script>
import Api from "@/api.js";
import swal from "sweetalert";

import Table from "@/components/Common/Table";
import AlertBox from "@/components/Common/Alerts/AlertBox";
import NavigationTabs from "@/components/Settings/Events/NavigationTabs.vue";

export default {
  name: "Instructors.vue",

  components: {
    Table,
    AlertBox,
    NavigationTabs
  },

  data() {
    return {
      instructors: [],
      loading: false,
      updating: false,
      failedRequest: false,
      metaData: null,
      fetchParams: {
        page: 1,
        per_page: null,
        to: 1,
        search: ""
      },
      selectedInstructorId: null,
      componentKey: 0
    };
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (
        vm.$route.query.instructor_deleted === true ||
        vm.$route.query.instructor_deleted === "true"
      ) {
        swal("Success!", "The instructor was deleted.", "success").then(() => {
          window.history.pushState(
            {},
            document.title,
            window.location.pathname
          );
        });
      }
      vm.getInstructors(() => {
        //
      });
    });
  },

  beforeRouteUpdate(to, from, next) {
    if (to.query.instructor_deleted === true) {
      swal("Success!", "The instructor was deleted.", "success").then(() => {
        window.history.pushState({}, document.title, window.location.pathname);
      });
    }
    this.forceRerender();
    if (
      this.fetchParams.to % this.fetchParams.per_page === 0 &&
      this.fetchParams.page !== 1
    ) {
      this.fetchParams.page -= 1;
    }
    this.getInstructors(() => {
      //
    });
    next();
  },

  mounted() {
    //
  },

  methods: {
    getInstructors(successCallback) {
      if (this.loading) {
        return;
      }

      this.loading = true;
      this.instructors = [];
      const endpoint = this.$partnerEndpoint("instructors");

      Api()
        .get(endpoint, {
          params: {
            page: this.fetchParams.page,
            search: this.fetchParams.search
          }
        })
        .then(response => {
          this.instructors = response.data.data;
          this.metaData = response.data.meta;
          this.failedRequest = false;
          if (typeof successCallback == "function") {
            successCallback();
          }
        })
        .catch(() => {
          this.failedRequest = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    deleteInstructor(instructorId) {
      this.selectedInstructorId = instructorId;
      if (this.loading || this.updating || this.selectedInstructorId == null) {
        return;
      }

      swal({
        title: "Are you sure?",
        text: "The instructor will be deleted",
        icon: "warning",
        dangerMode: true,
        buttons: {
          cancel: {
            visible: true,
            text: "Cancel",
            closeModal: true
          },
          confirm: {
            visible: true,
            text: "Yes, delete it!",
            closeModal: true
          }
        }
      }).then(isConfirm => {
        if (isConfirm) {
          const endpoint = this.$partnerEndpoint(
            "instructors/" + this.selectedInstructorId
          );

          Api()
            .delete(endpoint)
            .then(() => {
              this.$router
                .push({
                  name: "EventInstructors",
                  query: { instructor_deleted: true }
                })
                .catch(error => {
                  console.log(error);
                  if (
                    error.name === "NavigationDuplicated" ||
                    error.message.includes(
                      "Avoided redundant navigation to current location"
                    )
                  ) {
                    swal("Success!", "The instructor was deleted.", "success");
                    this.getInstructors(() => {
                      //
                    });
                  }
                });
            })
            .catch(error => {
              if (error.response.status === 403) {
                swal({
                  title: "Missing permission",
                  text: "You are not allowed to delete instructors.",
                  icon: "error"
                  //dangerMode: true,
                });
              }
            });
        } else {
          //
        }
      });
    },

    getCategoryNames(categories) {
      if (categories == null) {
        return "";
      }

      let categoryNames = "";
      for (let i = 0; i < categories.length; i++) {
        categoryNames += categories[i].name;
        if (i < categories.length - 1) {
          categoryNames += ", ";
        }
      }
      return categoryNames;
    },

    forceRerender() {
      this.componentKey += 1;
    },

    isActiveTab(tab) {
      return this.$route.name == tab;
    }
  }
};
</script>

<style scoped>
.mt-0 {
  margin-top: 0rem;
}

.mt-8 {
  margin-top: 1.3rem;
}

.mb-0 {
  margin-bottom: 0rem;
}

.mb-1 {
  margin-bottom: 0.3rem;
}

.mb-2 {
  margin-bottom: 0.6rem;
}

.mb-8 {
  margin-bottom: 1.3rem;
}

.checkbox-fixed-width {
  width: 50px;
}

.v-table-checkbox-label {
  margin-left: 10px;
}

.v-table-checkbox {
  position: relative !important;
}

.min-width-auto {
  width: 50px;
}
</style>
